module.exports = __webpack_public_path__ + "img/charlotte-min.feee31bf.png";